import { EachWorkdeskTicketI } from 'store/models/workdesk-tickets/each-workdesk-ticket.interface';
import { getApiInstance } from '../helpers';

const postWorkdeskManualSi = (
  ticketIdSiList: { id: string; si: boolean }[],
): Promise<EachWorkdeskTicketI[]> => {
  return getApiInstance()
    .post(
      '/ticket/update-si',
      ticketIdSiList.map((ticket) => ({
        ticketId: ticket.id,
        si: ticket.si,
      })),
    )
    .then((res) => {
      console.debug(`/ticket/update-si res.data `, res.data);
      if (!res.data)
        throw Error(
          `/ticket/update-si didn't return new tickets data`,
        );
      return res.data;
    });
};
export const manualSiService = {
  postWorkdeskManualSi,
};
